
<div>
	<v-container align="center" justify="center" class="pa-5 pb-0">
		<v-list-item three-line>
			<v-list-item-content>
				<v-list-item-title class="mb-1 text-center text-wrap"><h1>Payment information</h1></v-list-item-title>
				<v-list-item-subtitle class="text-center text-wrap">Where should we deposit your payments?</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>
	</v-container>

	<v-card-text align="center" justify="center" class="justify-center text-center pb-0 pm-0">
		<locum-bank-details-form :solo="false"></locum-bank-details-form>
	</v-card-text>
</div>
